import { render, staticRenderFns } from "./ExtendedKategorie.vue?vue&type=template&id=3dbdf659&scoped=true&"
import script from "./ExtendedKategorie.vue?vue&type=script&lang=js&"
export * from "./ExtendedKategorie.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedKategorie.vue?vue&type=style&index=0&id=3dbdf659&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbdf659",
  null
  
)

export default component.exports